<template lang="html">
    <div class="listchat layout-page" :style="stylechat">
      <!-- <MenuLayout/> -->
      <!-- <v-layout row wrap justify-center align-center class="mt-1 pl-3 pr-3" @click="InputFocusCancel()">
        <v-col
          cols="2"
          justify="center"
          align="center" 
          class="pa-0"
        >
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('LeftSide.header.chat')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pt-1 pa-0"
          @click="openMenu()"
        >
          <img :src="`${publicPath}/assets/img/icons/addx24.png`" alt="">
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider> -->
      <v-layout row wrap justify-start align-center class="pt-4 pl-5 pr-5 pb-5">
        <v-text-field
          ref="search"
          id="searchtext"
          v-model="search"
          :placeholder="$t('LeftSide.searching')"
          prepend-inner-icon="mdi-magnify"
          solo
          dense
          hide-details
          clearable
          class="pr-1"
          @focus="InputFocus($event)"
        ></v-text-field>
      </v-layout>
      <div class="layout-listchat">
        <vue-pull-refresh :on-refresh="onRefresh" :config="config">
          <div v-if="progress" class="ma-2">
            <v-progress-linear
              indeterminate
              size="64"
              color="#2463af"
              rounded
              height="8"
            ></v-progress-linear>
          </div>
          <v-list two-line nav v-if="FilterListchat.length !== 0">
            <v-menu
              v-model="showMenu"
              :position-x="x"
              :position-y="y"
              absolute
              offset-y
            >
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in ListBottomItem"
                  :key="index"
                  @click="emitListBottom(item)"
                >
                  <v-list-item-title>{{
                    item.text
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-list-item-group color="#2563af" v-model="tokenroom" active-class="#2563af" :mandatory="tokenroom !== -1 ? true : false">
              <template v-for="(item, index) in FilterListchat">
                <v-list-item
                  :key="index"
                  @click="routePage(item, index)"
                  @contextmenu="
                  menuListchat(
                    $event,
                    {
                      openchat: { value: true, room: item.room_id },
                      pin: item.pin,
                      mute: item.mute,
                      room: 'delete-chat',
                      index: index,
                    },
                    item,
                    index
                  )
                "
                v-touch="{
                    left: () => swipe('Left', index),
                    right: () => swipe('Right', index)
                }"
                >
                  <v-list-item-action @click="updatePin(item, index)" v-if="swipe_state === 'Right' && swipe_index === index">
                    <v-row justify="center" align="center" :class="item.pin === 'true' ? 'bg-list-swipe-unpin' : 'bg-list-swipe-pin'">
                      <v-avatar size="40">
                        <v-icon class="icon-color-white" v-if="item.pin === 'true'">mdi-pin-off</v-icon>
                        <v-icon class="icon-color-white" v-else>mdi-pin</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-list-item-action>
                  <v-list-item-action v-if="item.pin === 'true'">
                    <v-badge
                      avatar
                      overlap
                      bottom
                      offset-x="15"
                      offset-y="20"
                    >
                      <template v-slot:badge>
                        <v-avatar>
                          <v-img :src="`${publicPath}/assets/img/icons/pin@3x.png`"></v-img>
                        </v-avatar>
                      </template>
  
                      <v-avatar size="50">
                        <v-img v-if="item.picture" :src="item.picture" class="img-position" lazy="loading" :lazy-src="item.picture"></v-img>
                        <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                        <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/group-white.png`" lazy="loading" alt="" class="img-position">
                        <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/business-white.png`" lazy="loading" alt="" class="img-position">
                        <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/man-white.png`" lazy="loading" alt="" class="img-position">
                      </v-avatar>
                    </v-badge>
                  </v-list-item-action>
                  <v-list-item-action v-else>
                    <v-avatar size="50">
                      <v-img v-if="item.picture" :src="item.picture" class="img-position" :lazy-src="item.picture" lazy="loading"></v-img>
                      <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                      <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/group-white.png`" lazy="loading" alt="" class="img-position">
                      <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/business-white.png`" lazy="loading" alt="" class="img-position">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/man-white.png`" lazy="loading" alt="" class="img-position">
                    </v-avatar>
                  </v-list-item-action>
                  <v-list-item-content class="pt-0">
                    <v-list-item-title>
                      <!-- v-text="item.name" class="text-overflow pt-2" -->
                      <v-row
                        class="pl-3 pt-2 justify-start align-center"
                        style="height: 55px;"
                      >
                        <p :class="item.type !== 'group' ? 'text-overflow mb-0 pt-0' : 'text-overflow-group mb-0 pt-0'">
                          {{
                            item.name
                          }}
                        </p>
                        <span
                          class="pl-2"
                          v-if="
                            item.type === 'group' && item.count_member !== '0'
                          "
                          >({{ item.count_member }})</span
                        >
                        <v-icon
                          class="icon-color-notactive pl-2 pt-0 fz-14"
                          v-if="item.mute === 'true'"
                          >fa-solid fa-volume-xmark</v-icon
                        >
                      </v-row>
                    </v-list-item-title>
                    <v-list-item-subtitle class="tab-title-status text-overflow">
                      <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'">
                        {{$t('LeftSide.chat.leftChat')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'message' && item.file_name === ''" v-html="convertMsg(item.message)"></span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'message' && item.file_name !== ''" v-html="convertMsg(item.file_name)"></span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'">
                        {{$t('LeftSide.chat.sendSticker')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'file' || item.typeofmessage == 'password_file'">
                       {{$t('LeftSide.chat.sendFile')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'">
                        {{$t('LeftSide.chat.sendLocation')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'">
                        {{$t('LeftSide.chat.sendContact')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'">
                        {{$t('LeftSide.chat.sendPicture')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'">
                        {{$t('LeftSide.chat.sendNote')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'">
                        {{$t('LeftSide.chat.sendVideo')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'">
                        {{$t('LeftSide.chat.sendReply')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'">
                        {{$t('LeftSide.chat.createAlbum')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'">
                        {{$t('LeftSide.chat.createTask')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'">
                        {{$t('LeftSide.chat.createProject')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'">
                        <!-- ยกเลิกข้อความ -->
                        {{item.message}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'">
                        {{$t('LeftSide.chat.sendCarousel')}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'">
                        {{$t('LeftSide.chat.sendConference_msg')}}
                      </span>
                      <span class='fontselectchat text2' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'">
                        {{item.message}}
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'">
                        <div v-if="item.message === 'success'" class="text2">
                          <v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}} {{secondsToHms(item.time_count)}}
                        </div>
                        <div v-else-if="item.message === 'decline' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                        </div>
                        <div v-else-if="item.message === 'decline' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                        </div>
                        <div v-else-if="item.message === 'cancle' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                        </div>
                        <div v-else-if="item.message === 'cancle' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                        </div>
                        <div v-else-if="item.message === 'cancel' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                        </div>
                        <div v-else-if="item.message === 'cancel' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                        </div>
                      </span>
                      <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'">
                        <div v-if="item.message === 'invite'" class="text2">
                          {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                        </div>
                        <div v-else-if="item.message === 'kick'" class="text2">
                          <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม -->
                          {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser === tokenuser">
                          {{$t('ChatSide.system.self.leftGroup')}}
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser !== tokenuser" class="text2">
                          <!-- {{item.nickname}} ออกจากกลุ่ม -->
                          {{$t('ChatSide.system.other.leftGroup', { name: item.nickname} )}}
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser === tokenuser">
                          <!-- คุณเข้าร่วมกลุ่ม -->
                          {{$t('ChatSide.system.self.joinGroup')}}
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser !== tokenuser" class="text2">
                          <!-- {{item.nickname}} เข้าร่วมกลุ่ม -->
                          {{$t('ChatSide.system.other.joinGroup', { name: item.nickname} )}}
                        </div>
                      </span>
                      <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'">
                        <!-- เริ่มต้นการสนทนา -->
                        {{$t('LeftSide.chat.startChat')}}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="pb-2" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                    <v-list-item-action-text class='fontselectchat' v-text="time(item.timestamp)"></v-list-item-action-text>
                    <v-badge
                      overlap
                      color="red"
                      offset-y="10"
                      offset-x="25"
                      content="+99"
                      v-if="parseInt(item.count_read) >= 100"
                    >
                    </v-badge>
                    <v-badge
                      overlap
                      color="red"
                      offset-y="10"
                      offset-x="20"
                      :content="item.count_read"
                      v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''"
                    >
                    </v-badge>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index < FilterListchat.length - 1"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          <v-row v-else class="justify-center align-center mt-5" style="height: 100px;">
            <h3 v-if="search !== '' && search !== null">{{ $t('LeftSide.noDataSearching') }}</h3>
            <h3 v-else>{{ $t('LeftSide.noListChat') }}</h3>
          </v-row>
        </vue-pull-refresh>
      </div>
      <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
      <!-- <ListchatMenu :ListchatMenu="ListchatMenu" @closeListMenu="closeListMenu"/> -->
    </div>
  </template>
  
  <script>
  import { sync } from 'vuex-pathify'
  import { Momenttime, Encode, Decode } from '@/services'
  import ListchatMenu from '@/components/ListchatMenu'
  import MenuLayout from '@/views/MenuLayout'
  import WarningDialog from '@/components/Alert/Warning'
  var VuePullRefresh = require('vue-pull-refresh')
  var _ =require('lodash')
  
  export default {
    data() {
      return {
        WarningDialog: false,
        WarningDialogDetail: {},
        tokenroom: null,
        focusKey: false,
        swipe_state: '',
        swipe_index: 0,
        publicPath: process.env.VUE_APP_BASE_PATH,
        config: {
          progress: false,
          errorLabel: '',
          startLabel: '',
          readyLabel: '',
          loadingLabel: '',
          pullDownHeight: 20
        },
        ListchatMenu: false,
        search: '',
        stylechat: {
          "--Listchat-HeaderColor": "white",
          "--Listchat-TabBackground": "white",
          "--Listchat-Icon": "gray",
          "--Listchat-IconActive": "#2662ae",
          "--Listchat-Background": "white",
          "--Listchat-FontSize": "18px",
          "--Listchat-FontColor": "back",
          "--Listchat-FontSize-Status": "16px",
          "--Listchat-FontSize-Msg": "12px",
          "--Listchat-FontColor-Msg": "#6e6e6e",
          "--Listchat-FontColor-Status": "grey",
          "--Listchat-Background-Input": "#E2E1E3",
          "--Listchat-Color-Button": "#EFF2FE",
          "--Listchat-FontColor-Button": "#2662ae"
        },
        listchat: [],
        data_user: {},
        tokenuser: '',
        showMenu: false,
        x: 0,
        y: 0,
        ListBottomItem: [],
        data_room: {},
      }
    },
    components: {
      'vue-pull-refresh': VuePullRefresh,
      ListchatMenu,
      MenuLayout,
      WarningDialog
    },
    computed: {
      FilterListchat () {
        if (this.search !== '' && this.search !== null) {
          return this.listchat.filter(post => {
            return post.nickname.toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          return this.listchat
        }
      },
      ...sync('*')
    },
    mounted() {
      var me = this
      this.tokenroom = _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
      console.log("mouted listchat =>", this.tokenroom);
      
    },
    async created() {
      // console.log(this.themechat)
      var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
      this.data_user = user_profile['account']['profile']
      this.tokenuser = this.data_user.tokenuser
      await this.getListChat(this.data_user.tokenuser)
    },
    watch: {
      async '$route.params.tokenroom' () {
        // console.log("watch $route.params.tokenroom =>", this.$route.params.tokenroom);
        var me = this
        this.tokenroom = await _.findIndex(me.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
        // console.log("watch tokenroom =>", this.tokenroom);
      },
      async socketmessage (data) {
        if (data !== null) {
        // console.log("socket listchat => ", data)
        var me = this;
        var message = data.message
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexmsg !== -1) {
          // มีใน listchat เดิม
          this.listchat[indexmsg].is_active = 'true'
          var dataindex = this.listchat[indexmsg]
          dataindex.message = message
          dataindex.timestamp = data.timestamp
          dataindex.nickname = data.nickname
          dataindex.typeofmessage = data.typeofmessage
          dataindex.time_count = data.time_count
          dataindex.file_name = data.file_name
          dataindex.tokenuser = data.tokenuser
          if(dataindex.typeofmessage !== 'system_action') {
            dataindex.count_read = data.tokenroom === this.$route.params.tokenroom ? 0 : (parseInt(this.listchat[indexmsg].count_read) + 1).toString();
          }
          _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
          this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          // this.tokenroom = await _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
        } else {
          await this.getRoom();
          // ไม่มีใน listchat
          var new_chat = {
            count_member: this.data_room.count_member,
            count_read: data.tokenroom === this.$route.params.tokenroom ? 0 : 1,
            create_date: "",
            file_name: data.file_name,
            group_id: this.data_room.group_id,
            is_active: this.data_room.statemember,
            message: data.message,
            mute: "false",
            name: data.nickname,
            nickname: data.nickname,
            official_status: "",
            picture: data.path_pic,
            pin: "false",
            state: "active",
            time_count: "",
            timestamp: data.timestamp,
            tokenroom: data.tokenroom,
            tokenuser: this.tokenuser,
            tokenuser_sender: data.tokenuser,
            type: data.type,
            typeofmessage: data.typeofmessage
          }
          this.listchat.unshift(new_chat) // เพิ่ม lischat ใหม่เข้าไป        var me = this;
          // this.tokenroom = await _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
        }        
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = []
        var linstunpin = []
        this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
        this.listchat = _.union(listpin, linstunpin)
        // count read
        var indexblock = []
        var indexmessage = []
        var indexactive = []
        indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
        indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
        indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
        var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
        var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
        var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
        var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
        this.count_read = count - (countblock + countmsg + countactive)
        // select listchat
        this.tokenroom = await _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
        // console.log("watch this.tokenroom =>", this.tokenroom);
        }
      },
    },
    methods: {
      async getroom(tokenroom) {
        const body = {
          tokenuser: this.tokenuser,
          tokenroom: tokenroom
        }
        await this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', body).then((response) => {
          if (response.status === 200) {
            // console.log("room =>", response.data);
            return this.data_room = response.data
          }
        })
      },
      closeAlertDialog(item) {
        // console.log(item);
        if (item.type === "warning") {
          this.WarningDialogDetail = {}
          this.WarningDialog = false
        }
      },
      emitWarning (item) {
        // console.log(item);
        this.WarningDialogDetail = {}
        this.WarningDialog = false
        if (item.methods === "delete-chat") {
          this.deleteChat (item.detail, item.index)
        }
      },
      emitListBottom(item) {
        // console.log("emitListBottom", item);
        if (item.methods === "pin" || item.methods === "unpin") {
          this.updatePin(item.value, item.index);
        } else if (item.methods === "mute" || item.methods === "unmute") {
          this.updateMute(item.value, item.index);
        } else if (item.methods === "delete-chat") {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Left.deleteChatRoom'),
            detail: item.value,
            index: item.index,
            methods: item.methods
          }
          this.WarningDialog = true
        }
      },
      menuListchat(e, menu, item, idx) {
      // console.log(item);
      e.preventDefault(); // คลิกขวาแล้วไม่ให้แสดงเมนูของเว็บเบราว์เซอร์
      // console.log(menu)
      this.ListBottomItem = [];
      // if (menu.openchat.value === true) {
      //   this.ListBottomItem.push({
      //     text: this.$t("ChatSide.openNewTab"),
      //     methods: "openchat",
      //     icon: "",
      //     value: menu.openchat.room,
      //     name: item.name,
      //     index: idx,
      //   });
      // }
      if (menu.mute === "true") {
        this.ListBottomItem.push({
          text: this.$t("RightSide.unmute"),
          methods: "unmute",
          icon: "",
          value: item,
          index: idx,
        });
      }
      if (menu.mute === "false") {
        this.ListBottomItem.push({
          text: this.$t("RightSide.mute"),
          methods: "mute",
          icon: "",
          value: item,
          index: idx,
        });
      }
      if (menu.pin === "true") {
        this.ListBottomItem.push({
          text: this.$t("ChatSide.RightClickMenu.unpinChat"),
          methods: "unpin",
          icon: "",
          value: item,
          index: idx,
        });
      }
      if (menu.pin === "false") {
        this.ListBottomItem.push({
          text: this.$t("ChatSide.RightClickMenu.pinChat"),
          methods: "pin",
          icon: "",
          value: item,
          index: idx,
        });
      }
      if (menu.room === "delete-chat") {
        this.ListBottomItem.push({
          text: this.$t("ChatSide.RightClickMenu.deleteMsg"),
          methods: "delete-chat",
          icon: "",
          value: item,
          index: idx,
        });
      }

      if (this.ListBottomItem.length !== 0) {
        var me = this;
        this.x = e.clientX - 150;
        this.y = e.clientY;

        this.$nextTick(() => {
          me.showMenu = true;
        });
      }
    },
      InputFocus (evt) {
        // console.log(evt)
        const inputField = document.querySelector("#searchtext");
        const virtualKeyboardDetected = ''
        var me = this
        inputField.addEventListener("focusin", () => {
            console.log("Virtual keyboard detected! focusin")
            me.focusKey = true
            // window.addEventListener("resize", virtualKeyboardDetected )
        })
        // inputField.addEventListener("focusout", () => {
        //     console.log("Virtual keyboard detected! focusout")
        //     me.focusKey = false
        //     window.removeEventListener("resize", virtualKeyboardDetected )
        // })
      },
      InputFocusCancel () {
        this.listchat = this.listchat
        this.focusKey = false
        const inputField = document.querySelector("#searchtext");
        const virtualKeyboardDetected = ''
        var me = this
        // inputField.addEventListener("focusin", () => {
        //     console.log("Virtual keyboard detected! focusin")
        //     me.focusKey = true
        //     window.addEventListener("resize", virtualKeyboardDetected )
        // })
        inputField.addEventListener("focusout", () => {
          console.log("Virtual keyboard detected! focusout")
          me.focusKey = false
          // window.removeEventListener("resize", virtualKeyboardDetected )
        })
        console.log('InputFocusCancel')
  
      },
      deleteChat (item, index) {
        // console.log(item);
        // console.log(index);
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/setisactive', {
          tokenuser: this.tokenuser,
          tokenroom: item.tokenroom,
          is_active: "false"
        }).then((response) => {
          if (response.data.status === 'success') {
            this.listchat.splice(index, 1);
            this.$router.push('/web');
            localStorage.page = "chat";
            // this.swipe_state = ''
            // this.swipe_index = 0
          }
        }).catch(err => {
          console.log(err)
        })
      },
      updateMute (item, index) {
        var key = ''
        if (item.mute === 'true') {
          key = '0'
        } else {
          key = '1'
        }
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/set_mute_room', {
          tokenuser: this.tokenuser,
          tokenroom: item.tokenroom,
          mute_status: key
        }).then((response) => {
          if (response.data.status === 'success') {
            this.swipe_state = ''
            this.swipe_index = 0
            // pinchat
            this.listchat[index].mute = key === '0' ? 'false' : 'true';
            var listpin = []
            var linstunpin = []
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      updatePin (item, index) {
        var key = ''
        if (item.pin === 'true') {
          key = 'false'
        } else {
          key = 'true'
        }
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/setpin', {
          tokenuser: this.tokenuser,
          tokenroom: item.tokenroom,
          pin: key
        }).then((response) => {
          if (response.data.status === 'success') {
            this.swipe_state = ''
            this.swipe_index = 0
            // pinchat
            this.listchat[index].pin = key
            var listpin = []
            var linstunpin = []
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
            // console.log("pin listchat");
            // var me = this
            // this.tokenroom = _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
            
            // console.log(this.listchat)
            // console.log('this.swipe_state: ', this.swipe_state)
            // console.log('this.swipe_index: ', this.swipe_index)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      swipe (direction, index) {
        this.swipe_state = direction
        this.swipe_index = index
        // console.log('swipe: ', direction)
        // console.log('swipe index: ', index)
      },
      secondsToHms (d) {
        d = Number(d)
        var hours = Math.floor(d / 3600)
        var minutes = Math.floor((d - (hours * 3600)) / 60)
        var seconds = d - (hours * 3600) - (minutes * 60)
        var time = ''
  
        if (hours !== 0) {
          time = hours + ':'
        }
        if (minutes !== 0 || time !== '') {
          minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
          time += minutes + ':'
        }
        if (time === '') {
          time = seconds + ' วินาที'
        } else {
          time += (seconds < 10) ? '0' + seconds : String(seconds)
        }
        return time
      },
      convertMsg (msg) {
        msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2;">@');
        msg = msg.replace(/<\/tax>/g,'</span>');
        // console.log(msg)
        return msg
      },
      async getListChat (tokenuser) {
        this.progress = true
        await this.axios.post(process.env.VUE_APP_API_GO + `/v4/getListChat`, {
          tokenuser: tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            var me = this
            this.progress = false
            this.listchat = response.data['listchat']
            // pinchat
            var listpin = []
            var linstunpin = []
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
            // count_read
            var indexblock = []
            var indexmessage = []
            var indexactive = []
            indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
            indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
            indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
            var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
            var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
            var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
            var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
            this.count_read = count - (countblock + countmsg + countactive)
            // console.log('this.count_read: ', this.count_read)
            this.tokenroom = _.findIndex(this.listchat, function(o) { return o.tokenroom === me.$route.params.tokenroom })
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          this.listchat = []
        })
      },
      closeListMenu () {
        this.ListchatMenu = false
      },
      openMenu () {
        this.ListchatMenu = true
      },
      onRefresh () {
        // console.log('refresh')
        var me = this
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            me.getListChat(me.data_user.tokenuser)
            resolve();
          }, 1000);
        });
      },
      routePage (item, index) {
        if (this.swipe_state === 'Right' && this.swipe_index === index) {
          this.swipe_state = ''
          this.swipe_index = 0
        } else {
          this.search = null
          // this.InputFocusCancel()
          const inputField = document.querySelector("#searchtext");
          const virtualKeyboardDetected = ''
          var me = this
          inputField.addEventListener("focusout", () => {
            console.log("Virtual keyboard detected! focusout")
          })
          // this.listchat = this.listchat
          // this.focusKey = false
          var me = this
          if (item.type === 'bot') {
            setTimeout(function() {
              me.getConsent(item.tokenuser, item.tokenroom)
            }, 1000);
          } else {
            // console.log(`"goto chat`, `/chat-web/${item.tokenroom}`);
            setTimeout(function() {
              me.$router.push(`/chat-web/${item.tokenroom}`)
            }, 1000);
            // console.log("route" , this.$route);
          }
          // var me = this;
          // this.tokenroom = _.findIndex(this.listchat, function (o) { return o.tokenroom === me.$route.params.tokenroom })
          var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === item.tokenroom })
          this.listchat[indexmsg].is_active = 'true'
          this.listchat[indexmsg].count_read = 0
          this.mark_read(item)
        }
      },
      getConsent (botid, tokenroom) {
        this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/get-consent-bot', {
          tokenuser: this.data_user.tokenuser,
          bot_id: botid
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            if (response.data.isConsent === true && response.data.isAccept === false) {
              var dataConsent = Encode.encode(response.data.data)
              this.$router.push('/web/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
            } else {
              this.$router.push('/chat-web/' + tokenroom)
            }
          }
        }).catch(error => {
          console.log(error)
        })
      },
      mark_read (data) {
        // console.log(data)
        if (data.count_read !== '0' && data.count_read !== '') {
          this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {tokenuser: this.data_user.tokenuser, tokenroom: data.tokenroom}).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data);
            if (this.count_read !== 0) {
                this.count_read = this.count_read - response.data.s.length
            }
          }
        })
        }
      },
      time (timestamp) {
        if (this.$i18n.locale == 'th') {
          return Momenttime.dayjstimethaiformnow(timestamp)
        } else if (this.$i18n.locale == 'cn') {
          return Momenttime.dayjstimethaiformnowcn(timestamp)
        } else {
          return Momenttime.dayjstimethaiformnowen(timestamp)
        }
        // return Momenttime.dayjstimethaiformnow(timestamp)
      },
    }
  }
  </script>
  
  <style lang="css" scoped>
  .fz-14 {
    font-size: 14px !important;
  }
  .icon-color-notactive {
    color: gray;
  }
  .fz-18 {
    font-size: 18px !important;
  }
  >>>.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
    margin-bottom: 0px !important;
  }
  .icon-color-white {
    color: white !important;
  }
  .bg-list-swipe-unpin {
    background-color: var(--Listchat-IconActive) !important;
    height: 82px !important;
    width: 65px !important;
  }
  .bg-list-swipe-pin {
    /* background-color: white !important; */
    background-color: var(--Listchat-IconActive) !important;
    height: 82px !important;
    width: 65px !important;
    padding: 0 !important;
  }
  .fontselectchat {
    font-size: var(--Listchat-FontSize-Msg) !important;
    color: var(--Listchat-FontColor-Msg) !important;
  }
  .layout-listchat-focus {
    height: calc(100vh - 490px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .layout-listchat-focus::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listchat-focus::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  .layout-listchat {
    height: calc(100vh - 110px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .layout-listchat::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listchat::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  >>>.pull-down-container {
    /* padding: 0px !important; */
    /* overflow-y: hidden !important; */
    height: unset !important;
    max-height: unset !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }
  >>>.pull-down-container::-webkit-scrollbar {
    height: 10px;
    width: 0px;
  }
  >>>.pull-down-header {
    width: 100%;
    height: 0px;
    overflow: hidden;
    position: relative;
    background-color: var(--Listchat-Background) !important;
  }
  >>>.pull-down-content {
    position: absolute;
    max-width: 90%;
    bottom: 10px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    height: 40px;
    color: #0054ad;
    text-align: center;
    border-left: 20px solid transparent;
    font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }
  .tab-title {
    color: var(--Listchat-FontColor) !important;
    font-size: var(--Listchat-FontSize) !important;
    font-weight: 600;
  }
  .tab-title-status {
    color: var(--Listchat-FontColor-Status) !important;
    font-size: var(--Listchat-FontSize-Status) !important;
  }
  .text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 8vw;
  }
  .text-overflow-group {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 5vw;
  }
  .img-position {
    object-fit: cover;
    object-position: 50% 0;
    border-style: solid;
    border-width: thin;
    border-color: #e8e8e8;
  }
  >>>.v-input__slot {
    background-color: var(--Listchat-Background-Input) !important;
    border-radius: 10px !important;
  }
  >>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
  }
  .tab-title {
    color: var(--Listchat-FontColor) !important;
    font-size: var(--Listchat-FontSize) !important;
    font-weight: 600;
  }
  .layout-page {
    height: calc(100vh - 64px) !important;
    overflow: hidden !important;
    background-color: var(--Listchat-Background) !important;
  }
  </style>
  